import type { TableSourceDescriptor } from '../model';
import {
  buildVectorGeoJson,
  buildVectorTable,
  planTableDataExport,
  type VectorDataExportPlan,
} from './planning';
import { serializeCsvExport } from './csv';
import {
  createTextDataExportFile,
  CSV_MIME_TYPE,
  GEOJSON_MIME_TYPE,
  tableExportFilename,
  vectorExportFilename,
  type DataExportFile,
} from './browserFile';
import type { VectorExportFormat } from './model';

export async function prepareVectorDataExport(
  plan: VectorDataExportPlan,
  format: VectorExportFormat,
): Promise<DataExportFile> {
  if (format === 'geojson') {
    return createTextDataExportFile(
      JSON.stringify(buildVectorGeoJson(plan)),
      vectorExportFilename(plan.layer.name, format, plan.scope),
      GEOJSON_MIME_TYPE,
    );
  }
  return createTextDataExportFile(
    await serializeCsvExport(buildVectorTable(plan)),
    vectorExportFilename(plan.layer.name, format, plan.scope),
    CSV_MIME_TYPE,
  );
}

export async function prepareTableCsvExport(
  source: TableSourceDescriptor,
): Promise<DataExportFile> {
  return createTextDataExportFile(
    await serializeCsvExport(planTableDataExport(source)),
    tableExportFilename(source.name),
    CSV_MIME_TYPE,
  );
}
